module.exports = __webpack_public_path__ + "static/img/step-041.ad3d967.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-041.png
// module id = xBQs
// module chunks = 1